import { afterEvent, cardRef, defineGameCard } from '../authoring/index.js';
import { adultTreeDeathLeaf, applyThorns, growthOf, isLiveOnBoard, PLANT_GROWTH_ID, photosynthesis, removeGrowth, } from './plant-helpers.js';
/**
 * Зрелый тёрн — взрослая форма Саженца чёрного тёрна. За каждые 2 Роста
 * добавляет Колючки 2 в ячейку напротив. При Гибели оставляет Лист.
 */
export const MatureBlackthornCard = defineGameCard({
    id: 'mature_blackthorn',
    gameplay: {
        type: 'UNIT',
        cost: 3,
        baseStats: { attack: 8, health: 10 },
        traits: ['PLANT', 'TREE'],
    },
    presentation: {
        name: 'Зрелый тёрн',
        description: 'За каждые 2 Роста тратит их и накладывает Колючки 2 на ячейку напротив. Гибель: создайте Лист в этой ячейке.',
        glyph: {
            colors: ['#10213A', '#5D5B2D', '#9B9445', '#786B32', '#523F1E'],
            rows: [
                '......11111111......',
                '....11233444441.....',
                '...12444423253311...',
                '...112353244433141..',
                '..15352524242235241.',
                '.1333445224235243321',
                '1544442122213544321.',
                '12253521151314515441',
                '14515515211252143221',
                '.154553.5114.551521.',
                '.155.155.25.51..121.',
                '..1.2.5555125.11.1..',
                '...1211.1415.1221...',
                '...11121.35.12151...',
                '.....511.45.111.....',
                '....421..15..151....',
                '....551..55...1.....',
                '........1251........',
                '.......142321.......',
                '......11111111......',
            ],
        },
    },
    role: 'auxiliary',
    abilities: [
        ...photosynthesis(),
        afterEvent({
            event: 'EffectCounterChanged',
            run: {
                source: 'card_effect',
                dependencies: [cardRef(PLANT_GROWTH_ID), cardRef('plant_thorns')],
                run: (ctx, ...args) => {
                    const event = args[0];
                    const self = ctx.self;
                    if (!isLiveOnBoard(self)
                        || event.defId !== PLANT_GROWTH_ID
                        || event.key !== 'growth'
                        || event.scope.kind !== 'unit'
                        || event.scope.instanceId !== self.id)
                        return;
                    const count = Math.floor(growthOf(ctx, self.id) / 2);
                    if (count <= 0)
                        return;
                    const opposite = ctx.q.opposingCell(self.cellId);
                    if (opposite === null)
                        return;
                    removeGrowth(ctx, self.id, count * 2, 'blackthorn');
                    applyThorns(ctx, opposite.id, count * 2, self.controllerId);
                },
            },
        }),
        adultTreeDeathLeaf(),
    ],
    ui: { mechanics: ['growth', 'photosynthesis', 'thorns', 'death', 'token'] },
});
//# sourceMappingURL=mature_blackthorn.js.map